module.exports = __webpack_public_path__ + "img/tmenu1.06328176.png";